import { v4 as uuidv4 } from "uuid";

export default {
    data() {
        return {
            style: {},
            cll: {},
            mshow: false,
            searchKey: "",
            preloadFile: "",
            userAgent: "",
            asyncShow: false,
            webViewDestory: 0,
            isShowWin: false,
            protocolListen: [],
            mload: false,
            responseListener: false,
            beforeRequestListener: false,
        }
    },
    props: {
        //是否运行打开控制台
        debug: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        //用户session存储空间
        webviewKey: {
            type: String,
            default: () => {
                return "persist:chrome-common";
            }
        },
        //浏览器默认打开的url
        src: {
            type: String,
            default: () => {
                return "about:blank";
            }
        },
        //注入的js文件名称
        preload: {
            type: String,
            default: () => {
                return "qianniu/seller";
            }
        },
        webPreferences: {
            type: String,
            default: () => {
                return 'webSecurity=false,nodeIntegration=true,enableRemoteModule=true';
            }
        },
        //是否是手机端默认是PC端
        isMobile: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        zoom: {
            type: Number,
            default: () => {
                return 0;
            }
        },
        //显示日志前缀
        logName: {
            type: String,
            default: () => {
                return "浏览器";
            }
        },
        isFixUserAgent: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
    },
    created() {
        this.initLoad();
    },
    destroyed() {
        this.unLoad();
    },
    methods: {
        setStyle: function (style) {
            this.style = Object.assign({}, style);
        },
        loading: function () {
            this.mload = true;
        },
        unloading: function () {
            this.mload = false;
        },
        //组件销毁
        unLoad: async function () {
            this.webViewDestory = 1;
            await this.hideWebView();
        },
        isShow: function () {
            return this.mshow;
        },
        //页面初始化
        initLoad: function () {
            if (this.isMobile) {
                this.userAgent = this.getMobileUserAgent();
            } else {
                this.userAgent = this.getUserAgent();
            }
            if (window.require) {
                //加载注入的js文件
                if (process.env.NODE_ENV == "development") {
                    let rootPath = this.$call.sendSync("fileEvent.getAbsolutePath", "src/webviewjs/" + this.preload + ".js");
                    this.preloadFile = "file://" + rootPath;
                } else {
                    let rootPath = this.$call.sendSync("fileEvent.getAbsolutePath", "resources/app.asar/src/webviewjs/" + this.preload + ".js");
                    this.preloadFile = "file://" + rootPath;
                }
            }
        },
        //手机随机useragent
        getMobileUserAgent: function () {
            return "Mozilla/5.0 (Linux; U; Android 15; zh-cn; 24117RK2CC Build/AQ3A.240829.003) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.6261.119 Mobile Safari/537.36 XiaoMi/MiuiBrowser/19.7.20616";
        },
        //随机或者固定useragent isFix=true表示固定useragent
        getUserAgent: function () {
            return "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/129.0.0.0 Safari/537.36";
        },
        show: function () {
            return new Promise(async (callback) => {
                this.mshow = true;
                await this.showWebView();
                callback(true);
            });
        },
        showWin: function () {
            this.mshow = true;
            this.isShowWin = true;
        },
        //显示webview
        showWebView: function () {
            return new Promise((callback) => {
                if (!this.asyncShow) {
                    this.asyncShow = true;
                    this.$nextTick(() => {
                        this.webviewInit(callback);
                    });
                } else {
                    callback(true);
                }
            });
        },
        close: function () {
            if (this.mload) {
                this.$message({
                    type: "warning",
                    message: "加载中,禁止关闭窗口",
                });
                return;
            }
            if (this.isShowWin) {
                // console.log("隐藏窗口");
                this.closeWin();
            } else {
                // console.log("销毁窗口");
                return new Promise(async (callback) => {
                    this.mshow = false;
                    await this.hideWebView();
                    this.$emit("close");
                });
            }
        },
        closeWin: function () {
            this.mshow = false;
            this.isShowWin = false;
        },
        //隐藏webview
        hideWebView: function () {
            return new Promise((r) => {
                this.hideWebViewLoop(r);
            });
        },
        hideWebViewLoop: async function (r) {
            await this.callPromise("close", {}, 1, "close超时");
            // console.log("关闭webview完毕", this.mshow);
            this.asyncShow = false;
            this.$nextTick(() => {
                r(true);
            });
        },
        clearProtocolListen: function () {
            this.protocolListen = [];
        },
        delProtocolListen: function (scheme) {
            for (var pi in this.protocolListen) {
                var p = this.protocolListen[pi];
                if (p.scheme == scheme) {
                    this.protocolListen.splice(pi, 1);
                }
            }
        },
        addProtocolListen: function (scheme, handler) {
            var find = false;
            for (var pi in this.protocolListen) {
                var p = this.protocolListen[pi];
                if (p.scheme == scheme) {
                    find = true;
                    break;
                }
            }
            if (!find) {
                this.protocolListen.push({
                    scheme: scheme,
                    handler: handler,
                });
            }
        },
        ipcMessage: async function (event) {
            // console.log("event", event)
            if (event.channel) {
                let params = JSON.parse(event.channel);
                if (params.callback != undefined) {
                    // console.log("xxxxxxxxxxxxxxxxxxxxxxxx1",params);
                    // console.log("xxxxxxxxxxxxxxxxxxxxxxxx2",this.cll);
                    if (this.cll[params.action] != undefined) {
                        // console.log("xxxxxxxxxxxxxxxxxxxxxxxx3", params);
                        let result = await this.cll[params.action].resolved(params.data);
                        let data = {
                            action: params.callback,
                            data: result
                        };
                        // delete this.cll[params.action];
                        // console.log("xxxxxxxxxxxxxxxxxxxxx",params.callback,data);
                        this.callWebview(params.callback, data, event.frameId);
                    } else {
                        // console.log(`找不到事件${params.action}的回调:${params.callback}`,this.cll);
                    }
                } else {
                    this.callPromiseResult(params.action, params.data);
                }

            }
        },
        //初始化webview
        webviewInit: async function (callback) {
            var webview = this.$refs.webview;
            if (!webview && this.webViewDestory == 0) {
                return setTimeout(() => {
                    this.webviewInit(callback);
                }, 500);
            }
            if (this.webViewDestory == 0) {
                //移除消息
                this.$refs.webview.removeEventListener("ipc-message", this.ipcMessage);
                //消息绑定
                this.$refs.webview.addEventListener("ipc-message", this.ipcMessage);
                //自定义事件
                if (this.protocolListen && this.protocolListen.length > 0) {
                    for (var pi in this.protocolListen) {
                        var p = this.protocolListen[pi];
                        this.registerHttpProtocol(p.scheme, p.handler);
                    }
                }
                // console.log("webview src",this.src);
                //dom加载完毕
                webview.addEventListener("did-finish-load", (e) => {
                    this.callPromiseResult("go-finish-load-result", e);
                });
                //dom加载完毕
                webview.addEventListener("dom-ready", (e) => {
                    webview.setUserAgent(this.userAgent);
                    //缩放
                    if (this.zoom > 0) {
                        webview.setZoomFactor(this.zoom);
                    }
                    //console.log(this.logName,"dom ready",e.url);
                    this.callPromiseResult("go-result", e);
                    if (callback) {
                        window.require('@electron/remote/main').enable(webview);
                        callback(true);
                        this.bindCall("open-dev", () => {
                            //console.log(this.logName, "按下F12了");
                            this.showDebug();
                        });
                        callback = false;
                    }
                });

                // webview.setWindowOpenHandler((details) => {
                //     console.log("details",details.url);
                //     return { action: "deny" };
                // });
                // console.log("webContents",webview.webContents);
                //打开新的窗口
                webview.addEventListener('new-window', (e) => {
                    // console.log(this.logName, "new-window", e.url);
                    this.searchKey = e.url;
                    this.pageGo(e.url);
                    this.pageGoIn(e.url);
                });
                //will-navigate
                webview.addEventListener("will-navigate", (event, url) => {
                    // console.log(this.logName, "will-navigate", url);
                });
                // console.log("webview",webview.webContents);
                //崩溃
                webview.addEventListener('crashed', (e) => {
                    // console.log(this.logName, "crashed", e);
                });
                //页面跳转
                webview.addEventListener('did-navigate-in-page', (e) => {
                    // console.log(this.logName, "did-navigate-in-page", e.url);
                    this.searchKey = e.url;
                });
                var se = this.getSession(this.webviewKey);
                se.webRequest.onSendHeaders({
                    urls: [
                        //"*://*/*"
                    ],
                }, (details) => {
                    // console.log("请求前",details);
                    this.$emit("onSendHeaders", details);
                });
                se.webRequest.onResponseStarted({
                    urls: [
                        //"*://*/*"
                    ]
                }, (details) => {
                    if (this.responseListener) {
                        this.responseListener(details);
                    }
                    this.$emit("onResponseStarted", details);
                })
                se.webRequest.onCompleted({
                    urls: [
                        //"*://*/*"
                    ]
                }, (details) => {
                    this.$emit("onCompleted", details);
                })
                se.webRequest.onBeforeRequest({
                    urls: [
                        //"*://*/*"
                    ],
                }, (details, callback) => {
                    if (this.beforeRequestListener) {
                        this.beforeRequestListener(details, callback);
                    } else {
                        callback({});
                    }
                });
            } else {
                //组件已经销毁
                callback(false);
            }
        },

        //注入js文件回调过来
        callPromiseResult: function (action, params) {
            // console.log("========================action",action,params)
            if (this.cll[action] !== undefined) {
                if (this.cll[action].overT > 0) {
                    clearTimeout(this.cll[action].overT);
                }
                if (this.cll[action].resolved) {
                    this.cll[action].resolved(params);
                }
                if (!this.cll[action].noDelete) {
                    delete this.cll[action];
                }
            }
        },
        //只绑定回调。js注入文件回调回来
        bindCall: function (action, callback) {
            var info = {
                call: action,
                result: action + "-result",
                overT: 0,
                noDelete: true,
                "resolved": callback,
            };
            this.$set(this.cll, action, info);
        },
        //调用注入js文件里的函数
        callPromise: function (action, params, overTime = 0, overMessage = '', overTimeExtraParam = {}) {
            return new Promise((resolved) => {
                let ck = action + "-" + uuidv4() + "-result";
                // console.log("===========action", action, ",params", params)
                var info = {
                    call: action,
                    result: ck,
                    overT: 0,
                    "resolved": resolved,
                };
                if (overTime > 0) {
                    info.overT = setTimeout(() => {
                        if (overMessage === '') {
                            overMessage = "执行超时";
                        }
                        delete info.resolved;
                        resolved(Object.assign({ success: false, message: overMessage, info: info, isOverTime: 1 }, overTimeExtraParam));
                    }, 1000 * overTime);
                }
                this.$set(this.cll, info.result, info);
                this.callWebview(action, { action: ck, data: params });
            });
        },
        //调用注入js里的函数
        callWebview: function (evt, params, frameId) {
            var webview = this.$refs.webview;
            if (webview) {
                // console.log("send", evt, params);
                if (frameId) {
                    webview.sendToFrame(frameId, evt, params);
                } else {
                    webview.send(evt, params);
                }
                return true;
            } else {
                return false;
            }
        },
        //刷新浏览器
        refresh: function () {
            var webview = this.$refs.webview;
            if (webview) {
                webview.reload();
            }
        },
        getURL: function () {
            var webview = this.$refs.webview;
            if (webview) {
                return webview.getURL();
            }
        },
        //显示控制台
        showDebug: function () {
            var webview = this.$refs.webview;
            if (webview) {
                if (webview.isDevToolsOpened()) {
                    webview.closeDevTools();
                } else {
                    webview.openDevTools();
                }

            }
        },
        //验证字符串是否是url
        checkUrl: function (url) {
            if (!(/^(https?:\/\/)([0-9a-z.]+)(:[0-9]+)?([/0-9a-z.]+)?(\?[0-9a-z&=]+)?(#[0-9-a-z]+)?/.test(url))) {
                return false;
            }
            return true;
        },
        //搜索
        search: async function () {
            if (this.searchKey) {
                if (this.searchKey.indexOf("http") == -1) {
                    this.searchKey = "https://" + this.searchKey;
                }
            }
            if (!this.checkUrl(this.searchKey)) {
                this.$message({
                    type: "warning",
                    message: "无效网址",
                });
                return;
            }
            var r = await this.pageGo(this.searchKey);
            // console.log(this.logName, "跳转结果", r);
        },
        //页面跳转
        pageGo: function (url) {
            return new Promise(async callback => {
                var webview = this.$refs.webview;
                if (webview) {
                    try {
                        webview.setUserAgent(this.userAgent);
                        await webview.loadURL(url, {
                            userAgent: this.userAgent,
                        });
                        callback(1);
                    } catch (e) {
                        // console.log(e);
                        callback(3);
                    }
                } else {
                    //加载失败
                    callback(2);
                }
            });
        },
        //注入文件内跳转
        pageGoIn: function (url) {
            return this.callPromise("go", url, 5, "跳转超时");
        },
        //注入文件内跳转
        pageGoInFinishLoad: function (url) {
            return this.callPromise("go-finish-load", url, 5, "跳转超时");
        },
        //设置cookie
        setCookiePromise: function (key, url, cks) {
            return new Promise(resolved => {
                this.setCookieSync(key, url, cks, resolved);
            });
        },
        //自定义协议监听
        registerHttpProtocol: function (scheme, handler) {
            var remote = window.require("@electron/remote");
            var session = remote.session;
            var se = session.fromPartition(this.webviewKey);
            se.protocol.registerHttpProtocol(scheme, handler);
        },
        setCookie: async function (key, cookie) {
            if (window.require) {
                try {
                    var remote = window.require("@electron/remote");
                    var session = remote.session;
                    var se = session.fromPartition(key);
                    await se.cookies.set(cookie);
                } catch (error) {
                    // console.log("设置cookie出现异常", error);
                }
            }
        },
        //真实调用设置cookie
        setCookieSync: async function (key, url, cks, callback) {
            if (window.require) {
                var remote = window.require("@electron/remote");
                var session = remote.session;
                var se = session.fromPartition(key);
                var cookies;
                var newcookies = [];
                if (cks) {
                    cookies = cks;
                } else {
                    cookies = this.$utils.get(key);
                }
                for (var i in cookies) {
                    if (cookies[i].domain) {
                        var domain = cookies[i].domain;
                        if (domain.indexOf(".") == 0) {
                            cookies[i].url = "https://www" + domain;
                        } else {
                            cookies[i].url = "https://" + domain;
                        }
                    } else {
                        if (url) {
                            cookies[i].url = url;
                        }
                    }
                    var cook = JSON.parse(JSON.stringify(cookies[i]));
                    try {
                        if (cook.domain) {
                            if (!cook.domain.startsWith(".")) {
                                delete cook.domain;
                            }
                            if (!cook.sameSite) {
                                cook.sameSite = "unspecified";
                            }
                            await se.cookies.set(cook);
                            newcookies.push(cook);
                        }
                    } catch (err) {
                        // console.log(cook);
                        // console.log(err);
                    }
                }
                if (callback) {
                    callback(newcookies);
                }
            } else {
                if (callback) {
                    callback(false);
                }
            }
        },
        //读取cookie
        getCookiePromise: function (key, params) {
            return new Promise(resolved => {
                if (window.require) {
                    var remote = window.require("@electron/remote");
                    var session = remote.session;
                    var se = session.fromPartition(key);
                    var p = {};
                    if (params) {
                        p = params;
                    }
                    se.cookies.get(p).then((cookies) => {
                        resolved(cookies);
                    });
                } else {
                    resolved(false);
                }
            });
        },
        //读取cookie根据网站url 
        getCookies: function (url) {
            return new Promise(async (callback) => {
                //var tp = Object.prototype.toString.call(url);
                //console.log(this.logName, tp);
                var option = {};
                if (url) {
                    option.url = url;
                }
                var cookies = await this.getCookiePromise(this.webviewKey, option);
                callback(cookies);
            });
        },
        getCookiesV2: function (param) {
            return new Promise(async (callback) => {
                //var tp = Object.prototype.toString.call(url);
                //console.log(this.logName, tp);
                var option = {};
                if (param.url) {
                    option.url = param.url;
                }
                if (param.domain) {
                    option.domain = param.domain;
                }
                var cookies = await this.getCookiePromise(this.webviewKey, option);
                callback(cookies);
            });
        },
        //设置网站的cookies
        setCookies: function (url, cookies) {
            return new Promise(async (callback) => {
                var r = await this.setCookiePromise(this.webviewKey, url, cookies);
                callback(r);
            });
        },
        //等待webview内的页面事件绑定完毕
        waitPing: function (el) {
            return new Promise((r) => {
                this.waitPingLoop(r, el);
            });
        },
        waitPingLoop: async function (callback, el) {
            var rs = await this.ping(el);
            if (rs.success) {
                callback(rs);
            } else {
                if (this.webViewDestory == 0) {
                    setTimeout(() => {
                        this.waitPingLoop(callback, el);
                    }, 500);
                } else {
                    callback(false);
                }
            }
        },
        ping: function (el) {
            return this.callPromise("ping", el, 0.5, "ping超时");
        },
        call: function (action, params, overt = 1, overmsg = '超时') {
            return this.callPromise(action, params, overt, overmsg);
        },
        clear: async function () {
            //console.log(this.logName,"webviewKey",this.webviewKey);
            await this.clearCookie(this.webviewKey);
            await this.clearCache(this.webviewKey);
            await this.clearStorageData(this.webviewKey);
        },
        getSession: function (key) {
            if (window.require) {
                var remote = window.require("@electron/remote");
                // console.log("remote",remote);
                var session = remote.session;
                return session.fromPartition(key);
            }
            return;
        },
        setBeforeRequestListener: function (callback) {
            this.beforeRequestListener = callback;
        },
        clearBeforeRequestListener: function () {
            this.beforeRequestListener = false;
        },
        setResponseListener: function (callback) {
            this.responseListener = callback;
        },
        clearResponseListener: function () {
            this.responseListener = false;
        },
        //清空cookie
        clearCookie: async function (key) {
            try {
                var webviewSession = this.getSession(key);
                if (webviewSession) {
                    var cookies = await webviewSession.cookies.get({});
                    for (var i in cookies) {
                        var cookie = cookies[i];
                        var url = `${cookie.secure ? 'https' : 'http'}://${cookie.domain}${cookie.path}`;
                        await webviewSession.cookies.remove(url, cookie.name);
                    }
                    return true;
                }
            } catch (e) {
                // console.log("清空所有cookie出现异常", e);
            }
            return false
        },
        //清空缓存
        clearCache: async function (key) {
            try {
                var webviewSession = this.getSession(key);
                if (webviewSession) {
                    await webviewSession.clearCache();
                    return true;
                }
            } catch (e) {
                // console.log("清空所有clearCache出现异常", e);
            }
            return false
        },
        clearStorageData: function (key, options) {
            var se = this.getSession(key);
            if (se) {
                var op = {
                };
                if (options) {
                    op = Object.assign(op, options);
                }
                var rs = se.clearStorageData(op);
                //console.log("清空缓存");
                return rs;
            }
            return new Promise((resolve) => {
                resolve();
            });
        },
    }
}